import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, NgForm, FormControl, AbstractControl } from '@angular/forms';
import { ApiServicesService } from '../../../services/api-services.service';
import { AuthenticationService } from '../../../../../services/authentication.service';
import { FileUploadLibraryService } from "file-upload-library";
import * as errorUtils from "src/app/modules/utility/global-utils";
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationModalComponent } from "src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component";
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { environment } from "../../../../../../environments/environment";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { acceptedFileTypes } from 'app-models';
import { CustomErrorToastComponent } from 'custom-error-toast';
@Component({
  selector: 'app-form16-details',
  templateUrl: './form16-details.component.html',
  styleUrls: ['./form16-details.component.scss']
})
export class Form16DetailsComponent implements OnInit {
  form16Details: any;
  form16DetailsForm: FormGroup;
  @Input() detailsAbout: any;
  viewMode: boolean = false;
  showEditButton: boolean = true;
  editDetails: boolean = false;
  submitted: boolean = false;
  editModeVal: boolean = false;
  isForm16DetailsFormReset: boolean = false;
  form16UpdateProfile: boolean = false;
  beneficiaryType: string;
  employeeId: any;
  beneficiaryId: number;
  observableSubscription$ = new Subject();
  companyId: any;
  bulkDownloadCheckboxes: any[] = [];
  selectedFiles: any[] = [];
  bankDetailsArray: any;
  onlyFormBuilder: any;
  @Output() removeElement: EventEmitter<number> = new EventEmitter();
  @Output()
  profileEditStatus: EventEmitter<boolean> = new EventEmitter<boolean>();

  documentFileUploadConfigurations = {
    inputMultipleFlag: true,
    fileType: acceptedFileTypes,
    isFileListRequired: true,
    categoryName: 'FORM16DETAILSDOC',
    entityId: 1,
    fileCategory: '',
    listUploadedFiles: [],
    documentTypeRequired: true,
    docummentTypeCode: 'FORM16DETAILSDOC',
    useCase: 'beneficiary',
    useCaseId: 0,
    useEntityId: false,
    isDeleteEnabled: this.viewMode ? false : true,
    isUploadEnabled: this.viewMode ? false : true,
    familyId: null,
    family: false
  };

  constructor(private authenticationService: AuthenticationService, 
    private toastr: ToastrService,
    private apiService: ApiServicesService,
    private form16DetailsFormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public uploadService: FileUploadLibraryService,
    public dialog: MatDialog) { 
      this.companyId = parseInt(sessionStorage.getItem('companyId'));
      this.employeeId = parseInt(this.route.snapshot.queryParams.fbEmpId) ? parseInt(this.route.snapshot.queryParams.fbEmpId) : sessionStorage.getItem('employeeId');
      this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
      if(this.onlyFormBuilder === 'FB') {
        this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
      } else {
        this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
      }
    }

  ngOnInit(): void {
    this.setvalidatations();
    this.getForm16Details();
    this.documentFileUploadConfigurations.entityId = this.beneficiaryId;
    this.apiService.deletedfile$.subscribe((status) => {
      this.getForm16Details(); 
    });
  }

  getForm16Details() {
    this.apiService.getForm16Details(this.beneficiaryId, 'self').pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.form16Details = response;
    });
  }
  download(file) {
    const baseUrl = environment.docs.replace('/docs', '');
    this.uploadService.downloadDocuments(
      baseUrl + file.fileLocation.substring(23),
      file.fileLocation.substring(23)
    );
  }

  deleteDoc(item) {
    const title = "Confirm";
    const message = "Do you wish to Delete the File?";
    if (item) {
      this.dialogueInitializer(event, title, message)
        .afterClosed()
        .subscribe((result) => {
          if (result) {
            this.removeElement.emit(item);
          }
        });
    }
  }
  dialogueInitializer(event, title: string, message: string) {
    const cordinates: MouseEventInit = event;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: "400px",
      data: {
        update: { title, message },
        buttons: ["Cancel", "Delete"],
      },
    });
    return dialogRef;
  }

  setForm16FormData() {
    this.form16DetailsForm.patchValue({
      id: this.form16Details?.id,
      pfAccountNumber: this.form16Details?.pfAccountNumber,
      uanNumber: this.form16Details?.uanNumber,
      esiNumber: this.form16Details?.esiNumber,
      
    });

  }
  maxLengthValidator(maxLength: number) {
    return (control: AbstractControl) => {
      if (control.value && control.value.length > maxLength) {
        return { maxLength: true };
      }
      return null;
    };
  }
  setvalidatations() {
    this.form16DetailsForm = this.form16DetailsFormBuilder.group({
      id: [],
      pfAccountNumber : ['', [Validators.required, this.maxLengthValidator(30)]],
      uanNumber: ['', [Validators.required, this.maxLengthValidator(30)]],
      esiNumber: ['', [Validators.required, this.maxLengthValidator(30)]]
    });
  }
  handleEdit() {
    //  if (this.isform16DetailsFormReset) {
        this.setForm16FormData();
     //}
     this.editDetails = !this.editDetails;
     this.form16DetailsForm.enable();
     //this.editDetails ? this.subscribeValueChanges() : this.unSubscribeValueChanges();
     if (this.editDetails) {
       this.profileEditStatus.emit(true);
     } else {
       this.profileEditStatus.emit(false);
     }
   }
   saveForm16Data(isDraft: boolean = false) {
    if (!isDraft) {
      this.submitted = true;
      if (this.form16DetailsForm.invalid) {
        return;
      }
    }
   // if (this.form16DetailsForm.valid) {
      let id = 0; 

      if (this.form16DetailsForm.get('id').value !== null) {
        id = this.form16DetailsForm.get('id').value;
      }
    //let payload = this.form16DetailsForm.value
    let payload = { ...this.form16DetailsForm.value,
      companyId: this.companyId,
      employeeId: this.beneficiaryId,
      id: id };

    this.apiService.saveForm16Details(payload).subscribe(
      (response: any) => {
        this.toastr.success(response.message, 'Success');
        this.getForm16Details();
        this.clearProfileData(this.form16DetailsForm)
      },
      (error: any) => {
        CustomErrorToastComponent.showErrorToast(this.toastr, error);
      }
    );
   // }
  }

  clearProfileData(myForm) {
 
    this.isForm16DetailsFormReset = true;
    this.form16DetailsForm.disable();
    //myForm.resetForm();
    this.editDetails = !this.editDetails;
    this.profileEditStatus.emit(this.editDetails);
    this.setvalidatations();
  }

  saveAsDraft(event) {
    this.saveForm16Data(event);
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  backToTask() {
    const taskPageUrl = sessionStorage.getItem('redirectUrl');
    sessionStorage.removeItem('redirectUrl');
    this.router.navigate([`${taskPageUrl}`]);
  }

}
